import _ from "lodash";
import { combineReducers } from "redux";

const initialState = {
  currentView: "home",
  selectedLocations: [],
  selectedTargets: [],
  ageRange: [{ min: 13, max: 65 }],
  totals: null,
  results: []
};

function selectedTargets(
  selectedTargets = initialState.selectedTargets,
  action
) {
  let tgts = _.clone(selectedTargets);

  switch (action.type) {
    case "ADD_TARGET":
      if (!tgts[action.indexa]) {
        tgts[action.indexa] = [];
      }
      console.log(tgts,action)
      tgts[action.indexa].splice(action.indexb, 0, action.value);

      return tgts;
    case "REMOVE_TARGET":
      tgts[action.index] = _.without(tgts[action.index], action.value);
      if (tgts[action.index].length === 0) {
        tgts.splice(action.index, 1);
      }

      return tgts;
    case "REPLACE_TARGETS":
      let dragedTarget = tgts[action.dragIndexa][action.dragIndexb];
      tgts[action.dragIndexa].splice(action.dragIndexb, 1);
      if (!tgts[action.hoverIndexa]) {
        tgts[action.hoverIndexa] = [];
      }
      tgts[action.hoverIndexa].splice(action.hoverIndexb, 0, dragedTarget);
      return tgts;

    case "CLEAN_TARGETS":
      tgts = _.filter(tgts, ar => ar.length !== 0);
      tgts = tgts.map(vl => _.uniqWith(vl, _.isEqual));
      return tgts;
    case "UPDATE_ALL_INFORMATION":
      return _.map(action.data.targets, o => o);

    default:
      return selectedTargets;
  }
}

function currentView(currentView = initialState.currentView, action) {
  if (action.type === "TOGGLE_VIEW") {
    return action.destination;
  } else {
    return currentView;
  }
}

function ageRange(ageRange = initialState.ageRange, action) {
  if (action.type === "SET_AGE_RANGE") {
    return action.range;
  } else if(action.type == "UPDATE_ALL_INFORMATION"){
    return action.data.ages;

  } else {
    return ageRange;
  }
}

function selectedLocations(
  selectedLocations = initialState.selectedLocations,
  action
) {
  switch (action.type) {
    case "ADD_LOCATION":
      return _.uniqWith([...selectedLocations, action.location], _.isEqual);
    case "REMOVE_LOCATION":
      return _.without(selectedLocations, action.location);
    case "UPDATE_ALL_INFORMATION":
      return action.data.locations;
    default:
      return selectedLocations;
  }
}

function totals(totals = initialState.totals, action) {
  if (action.type === "SET_TOTALS") {
    return action.value;
  } else {
    return totals;
  }
}

function results(results = initialState.results, action) {
  switch (action.type) {
    case "ADD_RESULT":
      return [...results, action.result];
    case "RESET_RESULTS":
      return [];
    default:
      return results;
  }
}

const calculator = combineReducers({
  currentView,
  selectedLocations,
  selectedTargets,
  ageRange,
  totals,
  results
});

export default calculator;



// WEBPACK FOOTER //
// ./src/reducers/index.js